module.exports = __webpack_public_path__ + "img/product_6.76e9bfb.webp";